<template>
<x-y-chart
  :data-config="dataConfig"
  :unit-prop="unitProp"
  chart-type="line"
  :stack-type="0"
  :download-name="downloadName"
  :chart-min-height="chartMinHeight"
  :chart-height="chartHeight"
  selected-change-with-data-changed
  need-resize
/>
</template>

<script>
import XYChart from '../../DataChart/XYChart'

export default {
  name: 'DefaultChart',
  components: {XYChart},
  props: {
    dataConfig: {
      required: true,
      type: Object
    },
    unitProp: {
      required: true,
      type: String
    },
    factorGroupMap: {
      required: true,
      type: Object
    },
    downloadName: {
      type: String
    },
    chartMinHeight: {
      type: String
    },
    chartHeight: {
      type: String
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Data/ChartWrapper/DefaultChart.vue